// extracted by mini-css-extract-plugin
module.exports = {"help":"Help_help__rX8Qb","primary":"Help_primary__RkEi0","secondary":"Help_secondary__1jZSA"};